<template>
  <div class="order-wrap">
    <div class="order-top">
      <account-nav
        :type="'text'"
        :tabValue="'我的订单'"
        :slipper="false"
      >
      </account-nav>
      <div class="broadcast-message"><img src="~common/assets/img/warn.png" />实物及组合订单请于App端查看</div>
      <div
        class="fun-box"
        @mouseenter.self="filterShow = true"
        @mouseleave.self="hiddenFilter"
      >
        <span
          class="fun-show clearfix"
          @click="filterClick"
        >
          <span class="filter-tip">{{filterObj.displayName}}</span>
          <i class="filter-icon"></i>
        </span>
        <ul
          class="fun-check"
          v-show="filterShow"
        >
          <li
            :class="{'active': filterItem.filterNum === filterObj.filterNum}"
            v-for="filterItem in orderListFilter"
            :key="filterItem.filterNum"
            @click="clickFilterItem(filterItem)"
          >{{filterItem.displayName}}</li>
        </ul>
      </div>
    </div>
    <!-- 退费说明入口 -->
    <div
      class="refund-txt"
      @click="refundTxt"
    >
      <img
        src="../assets/img/icon_shuoming.png"
        alt=""
      >
      <span>退费说明</span>
    </div>
    <div class="order-lists-loading">
      <account-nav
        v-model="currType"
        :type="'tab'"
        :tabValue="listTabs"
        :slipper="true"
        :mainStyles="{'font-size':'12px','padding':'0 20px 10px 20px','line-height': '25px'}"
        :liStyles="{'margin-right':'20px','padding':'0'}"
        :baseline="false"
        @tabClick="tabClick"
      ></account-nav>
      <div
        class="ao-title-wrapper"
        v-show="listsData.length > 0"
      >
        <ul class="ao-title">
          <li class="ao-first">订单详情</li>
          <li class="ao-second">总计</li>
          <li class="ao-third">状态及操作</li>
        </ul>
      </div>
      <div class="order-lists">
        <!-- 订单列表 start-->
        <div
          class="ao-details order-wrapper"
          v-for="(list, index) in listsData"
          :key="index"
        >
          <div class="order-title-wrapper">
            <p class="or-title">
              <span class="time">{{list.createTime}}</span>
              <span class="number">订单号：{{list.orderNum}}</span>
              <!-- 订单顶部右侧的文案 -->
              <span class="right-tip">
                <span v-if="list.orderHint !== ''">{{list.orderHint}}</span>
                <span v-if="list.orderHint && list.promiseInfo">，</span>
                <span
                  style="color:#FE9B43"
                  v-if="list.promiseInfo !== ''"
                >{{list.promiseInfo}}</span>
              </span>
            </p>
            <p
              class="or-warning"
              v-if="list.hint"
            >
              <span
                class="orange"
                v-if="list.orderType == 3 && list.statusDesc == '已成团' && list.status != 2 && list.status != 1"
              >[已成团]</span>
              <span
                class="orange"
                v-if="list.orderType == 3 && list.statusDesc != '拼团失败' && list.statusDesc != '拼团成功' && list.statusDesc != '已成团' && list.status != 2 && list.status != 1"
              >[拼团中]</span>
              {{list.hint}}
            </p>
          </div>
          <!-- 商品订单 -->
          <div class="order-content-wrapper">
            <div
              class="order-course-wrapper"
              v-if="list.isShowAll"
            >
              <div class="or-con or-first">
                <!-- 课程信息 start -->
                <div
                  class="or-con-course-wrapper"
                  v-for="(product, productIndex) in list.productInfos"
                  :key="productIndex"
                >
                  <div class="or-con-course-left">
                    <div class="or-course">
                      <div
                        class="or-con-coupon"
                        v-if="product.couponInfo"
                      >
                        <div class="money-card-left">
                          <div class="money-card-ticket">
                            <p class="money-card-money">
                              <span class="money-card-sign">￥</span>{{product.couponInfo.discount.replace(/￥|¥/ig, '')}}
                            </p>
                            <p class="money-card-desc">{{product.couponInfo.threshold}}</p>
                          </div>
                          <div class="money-card-content">
                            <p class="money-card-name">{{product.couponInfo.productName}}</p>
                            <p class="money-card-time">{{product.couponInfo.receive_stime}} - {{product.couponInfo.receive_etime}}</p>
                          </div>
                        </div>
                        <div class="money-card-right">
                          <p class="money-card-price">￥{{product.realPrice}}</p>
                          <p class="money-card-num">x {{product.productNum}}</p>
                        </div>
                      </div>
                      <div
                        class="or-con-course"
                        v-else
                      >
                        <p class="course-name">
                          <span
                            v-if="product.basicInfos.productTag && product.basicInfos.productTag != ''"
                            class="presell-icon"
                          >{{product.basicInfos.productTag}}</span>
                          <span
                            class="xue-am-badge"
                            v-show="product.basicInfos.subjectName"
                          >{{product.basicInfos.subjectName}}</span>
                          <span class="text"><a
                              :href="product.basicInfos.productHref"
                              target="_blank"
                            >{{product.basicInfos.productName}}</a></span>
                        </p>
                        <!-- 兑换卡 -->
                        <div
                          class="ao-course-remarks"
                          v-if="product.productType == 202"
                        >
                          关注公众号即可选课哦，点击
                          <span
                            class="blue courseQrcode-btn"
                            @click="getQrcode($event)"
                          >扫码关注</span>
                        </div>
                        <span
                          class="course-time"
                          v-if="product.basicInfos.showName"
                        >
                          {{product.basicInfos.showName}}
                        </span>
                        <span v-if="product.basicInfos.showName && product.basicInfos.showName != '' && product.basicInfos.totalSections && product.basicInfos.totalSections > 0">· 共{{product.basicInfos.totalSections}}讲</span>
                        <span v-if="product.basicInfos.showName == '' && product.basicInfos.totalSections && product.basicInfos.totalSections > 0">共{{product.basicInfos.totalSections}}讲</span>
                        <!-- 主讲老师 -->
                        <p class="course-teacher">
                          <span
                            class="teach"
                            v-if="product.basicInfos.mainTeacher && product.basicInfos.mainTeacher.length > 0"
                          >授课：
                            <a
                              class="black"
                              v-for="(mainTea, teacherIndex) in product.basicInfos.mainTeacher"
                              :key="teacherIndex"
                              :href="mainTea.href"
                              target="_blank"
                            >
                              {{mainTea.teacherName}}
                            </a>
                          </span>
                          <span
                            class="teach"
                            v-if="product.basicInfos.foreignTeacher && product.basicInfos.foreignTeacher.length > 0"
                          >外教：
                            <a
                              class="black"
                              v-for="(mainTea, teacherIndex) in product.basicInfos.foreignTeacher"
                              :key="teacherIndex"
                              :href="mainTea.href"
                              target="_blank"
                            >
                              {{mainTea.teacherName}}
                            </a>
                          </span>
                        </p>
                      </div>
                      <div
                        class="or-con-price"
                        v-if="!product.couponInfo"
                      >
                        <p>￥{{product.realPrice}}</p>
                      </div>
                      <!-- 课程纬度操作 -->
                      <div class="or-con-price">
                        <div class="or-con or-course-operate">
                          <p
                            class="drop-detail-link"
                            v-if="[1,3].includes(+product.productStatus)"
                            @click="goDropDetail(product, list.orderNum)"
                          >{{getStatusText(product.productStatus)}}</p>
                          <p v-else-if="+product.productStatus === 2">{{getStatusText(product.productStatus)}}</p>
                          <!-- <p><span class="exchange-course" v-if="product.canChange == 1" @click="isCanChange(product.productType, product.stuProductId)">
                              <el-popover
                                popper-class="exchange-popover"
                                placement="bottom-end"
                                width="218"
                                trigger="click">
                                <span slot="reference" class="exchange-doc">调换课</span>
                                <ul class="exchange-content">
                                  <li :class="{'not-disabled': canSomeClick, 'disabled': !canSomeClick}" :disabled="!canSomeClick" @click="adjustTeacher()">
                                    <p><span class="exchange-icon"><img :src="exchangeTimeIcon" alt=""></span>
                                    <span class="exchange-text">调整上课时间/老师</span></p>
                                    <p class="exchange-tip" v-if="!canSomeClick">{{sameTxt}}</p>
                                  </li>
                                  <li :class="{'not-disabled': canDiffClick, 'disabled': !canDiffClick}" :disabled="!canDiffClick" @click="adjustVision()">
                                    <p><span class="exchange-icon"><img :src="exchangeVisionIcon" alt=""></span>
                                    <span class="exchange-text">调整课程难度/版本</span></p>
                                    <p class="exchange-tip" v-if="!canDiffClick">{{visionTxt}}</p>
                                  </li>
                                </ul>
                              </el-popover></span>
                            </p> -->
                          <p v-if="product.reSub == 1"><a
                              style="color: #f13232"
                              @click="dropReBuy"
                              target="_blank"
                            >重新选课</a></p>
                          <p v-if="product.canReturn == 1">
                            <a
                              class="return-style"
                              data-xeslog-params="key=xeslog_web_orderList_returncourse_ocenter&action=refund_course"
                              @click="applyReturn(list.orderNum, product.canChange, product.productType, product.returnParams, product.stuProductId)"
                            >申请退课</a>
                          </p>
                          <p
                            class="cancel-refund"
                            v-if="product.canReturn == 2"
                            @click="cancelRePay(product)"
                          >取消退课</p>
                        </div>
                      </div>
                    </div>
                    <!-- 福利 -->
                    <div
                      class="or-welfare"
                      v-if="product.giveawayInfos.length != 0"
                    >
                      <em class="welfare-icon">福利</em>
                      <span
                        v-for="(welfare, welfareIndex) in product.giveawayInfos"
                        :key="welfareIndex"
                      >
                        <div class="welfare welfare-name">
                          <span class="text">{{welfare.productName}} x {{welfare.productNum}}</span>
                        </div>
                        <div
                          class="welfare welfare-status"
                          v-if="welfare.productName != '其他赠品'"
                        >
                          <span
                            class="welfare-detail"
                            v-show="product.logisticsInfos"
                            v-for="(log, logIndex) in product.logisticsInfos"
                            :key="logIndex"
                          >
                            (<span>{{log.statusDesc}} ×{{log.num}}</span>)
                          </span>
                        </div>
                      </span>
                    </div>
                  </div>
                </div>
                <!-- 课程信息 end -->
                <div
                  class="show-all"
                  v-if="list.productInfos.length > 3"
                  @click="list.isShowAll = !list.isShowAll"
                >
                  {{list.isShowAll == false ? `余${list.productInfos.length - 3}项` : `收起` }}
                  <span :class="!list.isShowAll ? 'el-icon-arrow-down el-icon--down' : 'el-icon-arrow-up el-icon--up'"></span>
                </div>
              </div>
            </div>
            <div
              class="order-course-wrapper"
              v-if="list.isShowAll == false"
            >
              <div class="or-con or-first">
                <!-- 课程信息 start -->
                <div
                  class="or-con-course-wrapper"
                  v-for="(product, productIndex) in list.productInfos.slice(0,3)"
                  :key="productIndex"
                >
                  <div class="or-con-course-left">
                    <div class="or-course">
                      <div
                        class="or-con-coupon"
                        v-if="product.couponInfo"
                      >
                        <div class="money-card-left">
                          <div class="money-card-ticket">
                            <p class="money-card-money">
                              <span class="money-card-sign">￥</span>{{product.couponInfo.discount.replace(/￥|¥/ig, '')}}
                            </p>
                            <p class="money-card-desc">{{product.couponInfo.threshold}}</p>
                          </div>
                          <div class="money-card-content">
                            <p class="money-card-name">{{product.couponInfo.productName}}</p>
                            <p class="money-card-time">{{product.couponInfo.receive_stime}} - {{product.couponInfo.receive_etime}}</p>
                          </div>
                        </div>
                        <div class="money-card-right">
                          <p class="money-card-price">￥{{product.realPrice}}</p>
                          <p class="money-card-num">x {{product.productNum}}</p>
                        </div>
                      </div>
                      <div
                        class="or-con-course"
                        v-else
                      >
                        <p class="course-name">
                          <span
                            v-if="product.basicInfos.productTag && product.basicInfos.productTag != ''"
                            class="presell-icon"
                          >{{product.basicInfos.productTag}}</span>
                          <span
                            class="xue-am-badge"
                            v-show="product.basicInfos.subjectName"
                          >{{product.basicInfos.subjectName}}</span>
                          <span class="text"><a
                              :href="product.basicInfos.productHref"
                              target="_blank"
                            >{{product.basicInfos.productName}}</a></span>
                        </p>
                        <!-- 兑换卡 -->
                        <div
                          class="ao-course-remarks"
                          v-if="product.productType == 202"
                        >
                          关注公众号即可选课哦，点击
                          <span
                            class="blue courseQrcode-btn"
                            @click="getQrcode($event)"
                          >扫码关注</span>
                        </div>
                        <span
                          class="course-time"
                          v-if="product.basicInfos.showName"
                        >
                          {{product.basicInfos.showName}}
                        </span>
                        <span v-if="product.basicInfos.showName && product.basicInfos.showName != '' && product.basicInfos.totalSections && product.basicInfos.totalSections > 0">· 共{{product.basicInfos.totalSections}}讲</span>
                        <span v-if="product.basicInfos.showName == '' && product.basicInfos.totalSections && product.basicInfos.totalSections > 0">共{{product.basicInfos.totalSections}}讲</span>
                        <p class="course-teacher">
                          <span
                            class="teach"
                            v-if="product.basicInfos.mainTeacher && product.basicInfos.mainTeacher.length > 0"
                          >授课：
                            <a
                              class="black"
                              v-for="(mainTea, teacherIndex) in product.basicInfos.mainTeacher"
                              :key="teacherIndex"
                              :href="mainTea.href"
                              target="_blank"
                            >
                              {{mainTea.teacherName}}
                            </a>
                          </span>
                          <span
                            class="teach"
                            v-if="product.basicInfos.foreignTeacher && product.basicInfos.foreignTeacher.length > 0"
                          >外教：
                            <a
                              class="black"
                              v-for="(mainTea, teacherIndex) in product.basicInfos.foreignTeacher"
                              :key="teacherIndex"
                              :href="mainTea.href"
                              target="_blank"
                            >
                              {{mainTea.teacherName}}
                            </a>
                          </span>
                        </p>
                      </div>
                      <div
                        class="or-con-price"
                        v-if="!product.couponInfo"
                      >
                        <p>￥{{product.realPrice}}</p>
                      </div>
                      <!-- 课程纬度操作 -->
                      <div class="or-con-price">
                        <div class="or-con or-course-operate">
                          <p
                            class="drop-detail-link"
                            v-if="[1,3].includes(+product.productStatus)"
                            @click="goDropDetail(product, list.orderNum)"
                          >{{getStatusText(product.productStatus)}}</p>
                          <p v-else-if="+product.productStatus === 2">{{getStatusText(product.productStatus)}}</p>
                          <!-- <p><span class="exchange-course" v-if="product.canChange == 1" @click="isCanChange(product.productType, product.stuProductId)">
                            <el-popover
                              popper-class="exchange-popover"
                              placement="bottom-end"
                              width="218"
                              trigger="click">
                              <span slot="reference" class="exchange-doc">调换课</span>
                              <ul class="exchange-content">
                                <li :class="{'not-disabled': canSomeClick, 'disabled': !canSomeClick}" :disabled="!canSomeClick" @click="adjustTeacher()">
                                  <p><span class="exchange-icon"><img :src="exchangeTimeIcon" alt=""></span>
                                  <span class="exchange-text">调整上课时间/老师</span></p>
                                  <p class="exchange-tip" v-if="!canSomeClick">{{sameTxt}}</p>
                                </li>
                                <li :class="{'not-disabled': canDiffClick, 'disabled': !canDiffClick}" :disabled="!canDiffClick" @click="adjustVision()">
                                  <p><span class="exchange-icon"><img :src="exchangeVisionIcon" alt=""></span>
                                  <span class="exchange-text">调整课程难度/版本</span></p>
                                  <p class="exchange-tip" v-if="!canDiffClick">{{visionTxt}}</p>
                                </li>
                              </ul>
                            </el-popover>
                           </span></p> -->
                          <p v-if="product.reSub == 1"><a
                              style="color: #f13232"
                              @click="dropReBuy()"
                              target="_blank"
                            >重新选课</a></p>
                          <p v-if="product.canReturn == 1">
                            <a
                              class="return-style"
                              data-xeslog-params="key=xeslog_web_orderList_returncourse_ocenter&action=refund_course"
                              @click="applyReturn(list.orderNum, product.canChange, product.productType, product.returnParams, product.stuProductId)"
                            >申请退课</a>
                          </p>
                          <p
                            class="cancel-refund"
                            v-if="product.canReturn == 2"
                            @click="cancelRePay(product)"
                          >取消退课</p>
                        </div>

                      </div>
                      <!-- 对联报的待支付订单做处理 -->
                      <div
                        v-if="(list.productInfos.length == 2 && (list.status == 1 || list.status == 2)) ? 1 : list.productInfos.length == 1"
                        class="or-con or-course-operate"
                      >
                        <div>
                          <p
                            class="drop-detail-link"
                            v-if="[1,3].includes(+product.productStatus)"
                            @click="goDropDetail(product, list.orderNum)"
                          >{{getStatusText(product.productStatus)}}</p>
                          <p v-else-if="+product.productStatus === 2">{{getStatusText(product.productStatus)}}</p>
                          <p v-if="product.reSub == 1"><a
                              style="color: #f13232"
                              @click="dropReBuy()"
                              target="_blank"
                            >重新选课</a></p>
                          <p v-if="product.canReturn == 1">
                            <a
                              class="return-style"
                              data-xeslog-params="key=xeslog_web_orderList_returncourse_ocenter&action=refund_course"
                              @click="applyReturn(list.orderNum, product.canChange, product.productType, product.returnParams, product.stuProductId)"
                            >申请退课</a>
                          </p>
                          <p
                            class="cancel-refund"
                            v-if="product.canReturn == 2"
                            @click="cancelRePay(product)"
                          >取消退课</p>
                        </div>
                      </div>
                    </div>
                    <!-- 福利 -->
                    <div
                      class="or-welfare"
                      v-if="product.giveawayInfos.length != 0"
                    >
                      <em class="welfare-icon">福利</em>
                      <span
                        v-for="(welfare, welfareIndex) in product.giveawayInfos"
                        :key="welfareIndex"
                      >
                        <div class="welfare welfare-name">
                          <span class="text">{{welfare.productName}} x {{welfare.productNum}}</span>
                        </div>
                        <div
                          class="welfare welfare-status"
                          v-if="welfare.productName != '其他赠品'"
                        >
                          <span
                            class="welfare-detail"
                            v-show="product.logisticsInfos"
                            v-for="(log, logIndex) in product.logisticsInfos"
                            :key="logIndex"
                          >
                            (<span>{{log.statusDesc}} ×{{log.num}}</span>)
                          </span>
                          <!-- <p v-if="product.logisticsInfos == 0">×{{welfare.productNum}}</p> -->
                        </div>
                      </span>
                    </div>
                    <!-- 展开收起部分 -->
                  </div>
                </div>
                <!-- 余下2项 -->
                <div
                  class="show-all"
                  v-if="list.productInfos.length > 3"
                  @click="list.isShowAll = !list.isShowAll"
                >
                  {{list.isShowAll == false ? `余${list.productInfos.length - 3}项` : `收起` }}
                  <span :class="!list.isShowAll ? 'el-icon-arrow-down el-icon--down' : 'el-icon-arrow-up el-icon--up'"></span>
                </div>
                <!-- 课程信息 end -->
              </div>
            </div>
            <div class="or-con or-position or-second">
              <!-- 订单实付价格 -->
              <p>¥{{list.realPrice}}</p>
            </div>
            <!-- 订单维度的操作 -->
            <div class="or-con or-position or-third">
              <p>{{list.statusDesc}}</p>
              <p v-if="(list.status == 1 || list.status == 2) && list.orderType != 5"><a
                  data-xeslog-params="key=xeslog_web_orderList_pay_ocenter&action=goToPay_order"
                  :href="'https://trade.xueersi.com/Order/show?orderNum=' + list.orderNum+'&X-Businessline-Id='+bizId"
                  target="_blank"
                >立即支付</a></p>
              <p v-if="list.status == 1 || list.status == 2 "><a
                  data-xeslog-params="key=xeslog_web_orderList_cancel_ocenter&action=cancel_order"
                  href="javascript:void(0)"
                  @click="cancelClick(index)"
                >取消订单</a></p>
              <p><a
                  :href="list.detailHref"
                  target="_blank"
                >查看详情</a></p>
              <p v-if="list.seeExpress">
                <a
                  data-xeslog-params="key=xeslog_web_orderList_express_ocenter&action=click_look_express"
                  href="javascript:void(0)"
                  @click="showLogisticsDialog(index)"
                >
                  查看物流
                </a>
              </p>
              <p v-if="list.canModifyAddr">
                <a
                  data-xeslog-params="key=xeslog_web_orderList_addr_ocenter&action=click_modify_addr"
                  href="javascript:void(0)"
                  @click="showAddressDialog(index)"
                >
                  修改地址
                </a>
              </p>
              <p v-if="list.canAddAddr">
                <a
                  data-xeslog-params="key=xeslog_web_orderList_addr_ocenter&action=click_add_addr"
                  href="javascript:void(0)"
                  @click="addAddress(list.addAddrUrl)"
                >
                  填写地址
                </a>
              </p>
            </div>
          </div>
          <!-- 预售订单详情补充信息 -->
          <div
            class="pre-sell-order"
            v-if="list.orderType == 5"
          >
            <div class="pre-sell-stage">
              <div class="stage-left">
                <span>阶段一：定金</span>
                <span
                  class="price-info"
                  :class="{'price-red': list.status==1 || list.status==2}"
                >
                  <span>￥{{list.presaleOrderInfo.earnestPrice}}</span>
                </span>
              </div>
              <div
                class="status-desc"
                v-show="list.status == 1"
              >待支付</div>
              <div
                class="status-desc"
                v-show="list.status == 2"
              >支付中</div>
              <div
                class="status-desc"
                v-show="list.presaleOrderInfo.stage ==2 || list.status == 3"
              >已支付</div>
              <div
                class="operate-button-wrapper"
                v-show="list.status==1 || list.status==2"
              >
                <a :href="list.presaleOrderInfo.payHref">支付定金</a>
              </div>
            </div>
            <div class="pre-sell-stage">
              <div
                class="stage-left"
                :class="{'disabled-stage-left': list.presaleOrderInfo.tailTimeStatus != 2 || checkOrderIsCancel(list.status)}"
              >
                <span>阶段二：尾款</span>
                <div class="price-info">
                  <p :class="{'price-red': list.presaleOrderInfo.tailTimeStatus == 2 && list.presaleOrderInfo.stage==2}">￥{{list.presaleOrderInfo.tailPrice}}</p>
                </div>
                <div class="time-info">
                  <!-- 已取消和未到时间的显示开始和结束时间 -->
                  <span v-if="(checkOrderIsCancel(list.status) || list.presaleOrderInfo.tailTimeStatus != 2) && (list.presaleOrderInfo.tailStartTime && list.presaleOrderInfo.tailEndTime)">支付时间：{{list.presaleOrderInfo.tailStartTime.split(' ')[0].replace(/-/g, '.')}} - {{list.presaleOrderInfo.tailEndTime.split(' ')[0].replace(/-/g, '.')}}</span>
                  <!-- 倒计时 -->
                  <span
                    class="presell-order-list-count"
                    v-show="list.presaleOrderInfo.tailTimeStatus == 2 && list.presaleOrderInfo.stage==2"
                    v-html="list.timeStr"
                  ></span>
                  <!-- 倒计时停留在页面直到结束 -->
                  <span
                    v-show="list.presaleOrderInfo.tailTimeStatus == 3 && list.timeStr=='尾款支付时间已过'"
                    v-html="list.timeStr"
                  ></span>
                </div>
              </div>
              <div
                class="status-desc"
                v-show="list.status == 3"
              >已支付</div>
              <div
                class="status-desc status-desc-disabled"
                v-show="list.presaleOrderInfo.tailTimeStatus == 1 && !checkOrderIsCancel(list.status)"
              >未开始</div>
              <div
                class="operate-button-wrapper"
                v-show="list.presaleOrderInfo.tailTimeStatus == 2 && list.presaleOrderInfo.stage==2 && list.timeStr != '尾款支付时间已过'"
              >
                <a :href="list.presaleOrderInfo.payHref">支付尾款</a>
              </div>
            </div>
          </div>
        </div>
        <!-- 订单列表 end-->
      </div>
      <!-- 分页 -->
      <el-pagination
        class="order-page"
        v-if="total > pageSize"
        @current-change="pageChange"
        :current-page="currentPage"
        :page-size="pageSize"
        layout="prev, pager, next"
        :total="total"
      >
      </el-pagination>
      <!-- 选择服务弹框 -->
      <selectServer
        v-show="showSelectServer"
        :productType="productType"
        :returnParams="returnParams"
        :sameStatus="this.sameStatus"
        :diffStatus="this.diffStatus"
        :sameTxt="this.sameTxt"
        :diffTxt="this.diffTxt"
        @closeModel="closeSelectServer"
        @adjustVision="adjustVision"
        red="mySelectServer"
      ></selectServer>
      <!-- 错误提示 -->
      <error
        :type="'fail'"
        v-if="!ajaxStatus"
        :warning="warning"
        :mainStyles="{'margin-top': '115px'}"
      ></error>
      <!-- 为空提示 -->
      <error
        :type="'blank'"
        v-if="ajaxStatus == 1 && listsData.length == 0"
        :warning="filterObj.filterNum && currType !== 3 ? filterObj.displayName + '没有订单，可在左上角筛选全部' : '你还没有相关的订单'"
        :mainStyles="{'margin-top': '115px'}"
      ></error>
    </div>

    <!-- 物流弹框 -->
    <logistics-dialog
      ref="logistics"
      v-show="showLogistics"
      :orderId="editData.orderId"
      @closeLogisticsDialog="closeLogisticsDialog"
    ></logistics-dialog>

    <!-- 修改地址弹框 -->
    <address-dialog
      ref="address"
      :type="'edit'"
      :editData="editData"
      :showAddress="showAddress"
      :sourceType="sourceType"
      @closeAddressDialog="closeAddressDialog"
    ></address-dialog>
    <!-- 退费异常提示弹框 -->
    <accountModel
      v-show="showReFundModel"
      :modelStyles="{'width': '446px'}"
      :hasFooter="false"
      :notShowGray="true"
      @closeModel="closeReFundModel"
    >
      <div
        class="cancel-refund-header"
        slot="header"
      >
        <em
          class="el-icon-close"
          @click='closeReFundModel'
        ></em>
      </div>
      <div
        class="cancel-wrapper"
        slot="content"
      >
        <p :class="this.reduceProductInfos ? 'reduce-title' : 'cancel-common-title'">{{cancelRefundTxt}}</p>
        <!-- 商品信息部分 -->
        <div
          class="product-reduce-info"
          v-if="this.reduceProductInfos && this.reduceProductInfos.length > 0"
        >
          <div
            class="product-item"
            v-for="(item, index) in this.reduceProductInfos"
            :key="index"
          >
            <span>{{item.productName}}</span>
          </div>
        </div>
        <div
          class="cancel-footer"
          v-if="this.operateTxt && this.operateTxt.length > 0"
        >
          <span
            v-for="(item, index) in this.operateTxt"
            :key="index"
          >
            <button
              :class="item.status == 1 ? 'ok-btn' : ((item.status == 2 || item.status == 4) ? 'cancel-btn' : 'confirm-btn')"
              @click="operateClick(item.status)"
            >{{item.statusDesc}}</button>
          </span>
        </div>
      </div>
    </accountModel>
    <!-- 确定取消订单弹框 -->
    <accountModel
      v-show="showCancelModel"
      :modelStyles="{'width': '340px'}"
      :hasFooter="false"
      @closeModel="closeCancelModel"
    >
      <div
        class="cancel-wrapper"
        slot="content"
      >
        <p class="cancel-text">确定取消该订单吗？</p>
        <div class="cancel-order">
          <button
            class="cancel-btn"
            @click='confirmCancelModel'
          >确定</button>
          <button
            class="confirm-btn"
            @click='closeCancelModel'
          >取消</button>
        </div>
      </div>
    </accountModel>
    <!-- 取消退费弹框 -->
    <accountModel
      v-show="showMoneyModel"
      :modelStyles="{'width': '446px'}"
      :hasFooter="false"
      @closeModel="closeMoneyModel"
    >
      <div
        class="cancel-wrapper"
        slot="content"
      >
        <p class="cancel-text">{{this.cancelRefundTxt}}</p>
        <div
          v-if="this.cancelOperate == 2"
          class="cancel-footer"
        >
          <button
            class="cancel-btn"
            @click="closeMoneyModel"
          >取消</button>
          <button
            class="confirm-btn"
            @click="confirmRefund"
          >全部取消退课</button>
        </div>
        <div
          v-if="this.cancelOperate == 3"
          class="cancel-footer"
        >
          <button
            class="cancel-btn"
            @click="closeMoneyModel"
          >取消</button>
          <button
            class="confirm-btn"
            @click="confirmRefund"
          >确定</button>
        </div>
      </div>
    </accountModel>

    <!-- 取消订单成功与否提示弹框 -->
    <accountModel
      v-show="succCancel"
      :modelStyles="{'width': '300px'}"
      :hasFooter="false"
      :content="cacelWarning"
      @closeModel="closeSuccCancelModel"
    ></accountModel>

    <!-- 关注公众号提示 -->
    <qrcode-dialog
      v-show="showWX"
      ref="qrcode"
      @closeModel="closeQrcodeDialog"
    ></qrcode-dialog>

  </div>
</template>

<script>
import axios from '~common/assets/js/ocenter-axios.js'
import { Loading } from 'element-ui'
import accountModel from '@/components/sub/accountModel.vue'
import accountNav from '@/components/sub/accountNav.vue'
import error from '@/components/sub/error.vue'
import selectServer from '@/components/dialog/selectServer.vue'
import logisticsDialog from '@/components/dialog/logisticsDialog.vue'
import addressDialog from '@/components/dialog/addressDialog.vue'
import qrcodeDialog from '@/components/dialog/qrcodeDialog.vue'
import adjustCourse from '@/components/dialog/adjustCourse.vue'
import { business } from '@xes/trade-toolkit'
import config from '../config'
export default {
  name: 'account',
  metaInfo: {
    title: '我的订单-订单管理'
  },
  components: {
    accountNav,
    accountModel,
    error,
    logisticsDialog,
    addressDialog,
    qrcodeDialog,
    adjustCourse,
    selectServer
  },
  data() {
    const bizId = business.getCurrentBizId()
    return {
      bizId,
      returnParams: '',
      productType: '',
      sameStatus: '',
      diffStatus: '',
      sameTxt: '',
      diffTxt: '',
      listTabs: ['全部', '已支付', '未完成', '待支付', '已取消'], // 列表tab切换值
      currentPage: null,
      pageSize: 5,
      total: 0,
      currType: 0, // 当前列表tab的index
      listsData: [], // 订单列表数据
      showAddress: false, // 是否展示修改地址弹框
      editData: {
        orderId: '', // 订单id
        courseId: '' // 课程id
      },
      sourceType: '1', // 当前选中的订单类型 1-普通订单；2-兑换卡订单
      showReFundModel: false, // 是否展示
      showSelectServer: false, // 是否展示选择服务弹框
      showLogistics: false, // 是否展示查看物流弹框
      logistics: [],
      ajaxStatus: -1, // 订单信息请求状态：-1-未请求，0-请求失败，1-请求成功
      warning: '请求失败,请重试......',
      loadFlag: false,
      loadingInstance: null,
      loadingTimer: null,
      showWX: false, // 是否展示 关注公众号提示框
      showCancelModel: false, // 是否展示 取消订单提示框
      showMoneyModel: false, // 是否展示  取消退费提示框
      succCancel: false, // 是否展示 取消订单成功提示框
      currentCancelIndex: -1, // 当前取消订单的index
      cacelWarning: '',
      activeCourseInfo: {}, // 当前选中的课程
      presellStageStatusObj: {
        1: '待支付',
        2: '支付中',
        3: '支付成功',
        4: '已取消'
      },
      timerArr: [], // 支付尾款倒计时
      canSomeClick: true,
      canDiffClick: true,
      exchangeTimeIcon: require('../assets/img/tuifei_list_time_icon@2x.png'),
      exchangeVisionIcon: require('../assets/img/tuifei_list_difficulty_icon@2x.png'),
      exchangeContent: {},
      cancelRefundTxt: '', // 取消退费文案
      cancelRePayParams: {}, // 取消退费参数
      cancelOperate: '1',
      reductProductInfos: [],
      operateTxt: [], // 退费结果弹框操作
      reduceProductInfos: [],
      filterObj: {
        filterNum: 1
      },
      orderListFilter: [],
      filterShow: false
    }
  },
  created() {
    this.currentPage = isNaN(Number(this.$route.params.page)) ? 1 : Number(this.$route.params.page) // 设置当前页数
    this.currType = isNaN(Number(this.$route.params.type)) ? 0 : Number(this.$route.params.type) // 设置当前类型tab
  },
  mounted() {
    this.$xesLogger.loadMsg({
      pageuid: 'orderList',
      couponorder_status: this.$route.params.type
    })
    this.$nextTick(() => {
      // this.getTabs()
      this.getOrderList(this.currentPage)
    })
  },
  watch: {
    loadFlag: function () {
      if (!this.loadFlag) {
        this.loadingInstance.close()
        this.loadingInstance = null
      }
    },
    $route: function () {
      this.currentPage = isNaN(Number(this.$route.params.page)) ? 1 : Number(this.$route.params.page)
      this.currType = isNaN(Number(this.$route.params.type)) ? 0 : Number(this.$route.params.type) // 设置当前类型tab
      this.getOrderList(this.currentPage)
    }
  },
  methods: {
    clickFilterItem(item) {
      this.filterObj = item
      this.filterShow = false
      // this.currentPage = 1
      this.pageChange(1)
      // this.getOrderList(this.currentPage)
    },
    filterClick() {
      this.filterShow = !this.filterShow
    },
    hiddenFilter() {
      this.filterShow = false
    },
    operateClick(status) {
      // 取消
      if (status == 4) {
        this.showReFundModel = false
        this.getOrderList(this.currentPage)
      }
      // 好的
      if (status == 1) {
        this.showReFundModel = false
      }
      // 我知道了
      if (status == 2) {
        this.showReFundModel = false
        this.getOrderList(this.currentPage)
      }
      // 联系客服
      if (status == 3) {
        this.showReFundModel = false
        if (this.$common && this.$common.CustomerService) {
          this.$common.CustomerService.show({
            key: config.QiYuKey
          })
        }
      }
    },
    // 跳转选课中心
    dropReBuy() {
      window.location.href = 'https://online.xueersi.com/s'
    },
    // 判断课程是否可调换
    isCanChange(type, id) {
      this.canDiffClick = true
      this.canSomeClick = true
      this.sameTxt = ''
      this.visionTxt = ''
      axios.post('https://home.xueersi.com/Web/StuChangeCourse/checkStuOrderCourses', {
        productType: type,
        stuProductIds: id
      }).then(res => {
        // 同大纲可以调课
        this.exchangeContent = res.data
        if (res.data.sameOutlineCourse.status == 0) {
          this.canSomeClick = false
          this.exchangeTimeIcon = require('../assets/img/tuifei_list_time_icon@2x(1).png')
          this.sameTxt = res.data.sameOutlineCourse.statusName
        }
        // 跨大纲可以调课
        if (res.data.diffOutlineCourse.status == 0) {
          this.canDiffClick = false
          this.exchangeVisionIcon = require('../assets/img/tuifei_list_difficulty_icon@2x(1).png')
          this.visionTxt = res.data.diffOutlineCourse.statusName
        }
      })
    },
    // 调整上课时间/老师
    adjustTeacher() {
      // 跳转到学习中心首页
      window.location.href = 'https://i.xueersi.com/icenter/Web/StudyCenter/MyCourses/index'
    },
    // 调整课程难度/版本
    adjustVision() {
      if (Object.keys(this.exchangeContent).length != 0) {
        window.location.href = `https://home.xueersi.com/changeCourse/#/agreement/${this.exchangeContent.stuProductIds}/${this.exchangeContent.diffOutlineCourse.ruleId}/${this.exchangeContent.productInfo.classId}`
      } else {
        window.location.href = `https://home.xueersi.com/changeCourse/#/agreement/${this.returnContent.stuProductIds}/${this.returnContent.diffOutlineCourse.ruleId}/${this.returnContent.productInfo.classId}`
      }
    },
    // 退费说明
    refundTxt() {
      const params = {
        pageuid: '1',
        clickid: '1.3'
      }
      this.$xesLogger.clickMsg({
        params: params
      })
      window.location.href = 'https://online.xueersi.com/article/detail/1921'
    },
    // 申请退费
    applyReturn(orderNum, change, type, params, stuId) {
      this.productChange = change
      this.productType = type
      this.returnParams = params
      this.stuProductIds = stuId
      this.orderNum = orderNum
      // 检测是否可以退费
      // 次卡直接退费流程
      if (this.productType == 230) {
        this.$router.push({ name: 'OrderDropEcard', query: { productType: this.productType, returnParams: this.returnParams } }).catch(() => { })
      }
      // 课程订单退费流程
      axios.post(this.Service.Order.checkReturnProduct, {
        productType: this.productType,
        stuProductIds: this.stuProductIds
      }).then(res => {
        // 挽留流程的退费
        if (res.status == 1) {
          if (res.data.status == 1) {
            if (this.productChange == 1) {
              axios.post('https://home.xueersi.com/Web/StuChangeCourse/checkStuOrderCourses', {
                productType: type,
                stuProductIds: stuId
              }).then(res => {
                this.returnContent = res.data
                this.sameStatus = res.data.sameOutlineCourse.status
                this.diffStatus = res.data.diffOutlineCourse.status
                this.sameTxt = res.data.sameOutlineCourse.statusName
                this.diffTxt = res.data.diffOutlineCourse.statusName
                this.showSelectServer = true
              })
            } else {
              // 其他订单退费
              if (this.productType != 230) {
                this.$router.push({ name: 'OrderDrop', query: { productType: this.productType, returnParams: this.returnParams } }).catch(() => { })
              }
            }
          }
          if (res.data.status == 10006) {
            this.showReFundModel = true
            this.cancelRefundTxt = res.data.msg
            this.operateTxt = res.data.operateInfo
            if (res.data.productInfos && res.data.productInfos.length > 0) {
              this.reduceProductInfos = res.data.productInfos
            }
          }
        } else {
          this.$message.info(res.data)
        }
      }).catch(err => {
        if (err.data) {
          this.$message.error(err.data)
        }
      })
    },
    // 关闭退费异常提示弹框
    closeReFundModel() {
      this.showReFundModel = false
      this.getOrderList()
    },
    // 关闭取消退费弹框
    closeMoneyModel() {
      this.showMoneyModel = false
    },
    // 确定取消退费
    confirmRefund() {
      axios.post(this.Service.Order.cancelReturnProduct, {
        productType: this.cancelRePayParams.productType,
        stuProductIds: this.cancelRePayParams.stuProductId
      })
        .then((res) => {
          if (res.status == 1) {
            // 取消退费成功，刷新订单列表
            this.showMoneyModel = false
            if (res.data.msg) {
              this.$message.error(res.data.msg)
            }
            this.getOrderList()
          } else {
            this.$message.error(res.data)
          }
        })
    },
    // 取消退费
    cancelRePay(product) {
      if (product.refundProductType === 2) {
        // 取消退组合课
        this.showMoneyModel = true
        this.cancelRefundTxt = '该课程为组合课程，取消退课后该组合其他课程也会全部取消退课。'
        this.cancelOperate = 2
        this.cancelRePayParams = product
      } else {
        // 直接取消退费
        this.showMoneyModel = true
        this.cancelRefundTxt = '确定取消退课吗？'
        this.cancelRePayParams = product
        this.cancelOperate = 3
      }
    },
    goDropDetail(product, orderNum) {
      console.log(product)
      if ([1, 3].includes(+product.productStatus)) {
        let clickId = '1.1'
        if (+product.productStatus === 1) {
          clickId = '1.2'
        }
        const params = {
          pageuid: '1',
          clickid: clickId,
          order_number_id: orderNum,
          course_id: product.productId
        }
        this.$xesLogger.clickMsg({
          params: params
        })
      }
      const id = product.stuProductId
      const status = product.productStatus
      const productType = product.productType
      this.$router.push({
        name: 'OrderDropDetail',
        params: {
          id,
          orderNum,
          type: +status === 1 ? 2 : 1,
          productType
        },
        query: {
          id: product.productId
        }
      })
    },
    activeCourseInfoUpdate(res) { // 当前点击的课程信息更新
      this.activeCourseInfo = res
    },
    // tab切换点击事件
    tabClick(index) {
      clearTimeout(this.loadingTimer)
      this.loadFlag = false
      this.currType = index
      this.$router.push({ path: `/MyOrders/list/${this.currType}/1` }).catch(() => { })
    },
    // 获取订单tab切换的数据
    getTabs() {
      axios.post(this.Service.Order.ajaxUserOrderAmount)
        .then((res) => {
          if (res.status == 1) {
            this.listTabs.push('全部订单 ' + res.data.total)
            this.listTabs.push('已支付 ' + res.data.paid)
            this.listTabs.push('未完成 ' + res.data.unfinished)
            this.listTabs.push('待支付 ' + res.data.notyet)
            this.listTabs.push('已取消 ' + res.data.cancel)
          } else {
            this.listTabs.push('全部订单')
            this.listTabs.push('已支付')
            this.listTabs.push('未完成')
            this.listTabs.push('待支付')
            this.listTabs.push('已取消')
          }
        })
    },
    // 获取订单列表数据
    getOrderList(page) {
      if (!this.loadingInstance) {
        this.loading('.order-lists-loading')
      }
      document.body.scrollTop = document.documentElement.scrollTop = 0
      let tempIndex = this.currType
      if (this.currType == 2) {
        tempIndex = 4
      } else if (this.currType == 3 || this.currType == 4) {
        tempIndex -= 1
      }
      axios.post(this.Service.Order.ajaxGetOrderList, {
        curpage: page,
        perpage: this.pageSize,
        type: tempIndex,
        filterNum: this.filterObj.filterNum || undefined
      })
        .then((res) => {
          clearTimeout(this.loadingTimer)
          this.loadFlag = false
          if (res.status == 1) {
            this.ajaxStatus = 1
            // this.listsData = res.data.list
            this.createTimer(res.data.list)
            this.total = Number(res.data.total)
            this.orderListFilter = res.data.orderListFilter
            if (!this.filterObj.displayName) {
              this.filterObj = this.orderListFilter[0]
            }
          } else {
            this.ajaxStatus = 0
            this.listsData = []
            this.warning = res.data
          }
        })
        .catch(() => {
          clearTimeout(this.loadingTimer)
          this.loadFlag = false
          this.ajaxStatus = 0
          this.warning = '订单列表获取，请稍后重试～'
        })
    },

    // 页码切换
    pageChange(page) {
      this.$router.push({ path: `/MyOrders/list/${this.currType}/${page}` }).catch(() => { })
    },

    // 显示物流弹框；
    showLogisticsDialog(index) {
      this.editData.orderId = this.listsData[index].orderNum // 订单号
      this.showLogistics = true
      this.$refs.logistics.showThisDialog(this.editData.orderId)
    },
    // 关闭物流弹框；
    closeLogisticsDialog() {
      this.showLogistics = false
    },
    // 关闭选择服务弹框
    closeSelectServer() {
      this.showSelectServer = false
    },
    // 填写地址
    addAddress(address) {
      window.open(address)
    },
    // 显示 添加／修改地址弹框
    showAddressDialog(index) {
      this.showAddress = true
      this.editData.orderId = this.listsData[index].orderNum // 订单号
      this.$refs.address.addressEdit()
    },

    // 地址弹框关闭
    closeAddressDialog() {
      this.showAddress = false
    },

    // 获取关注公众号弹框
    getQrcode(event) {
      this.$refs.qrcode.setQrcode(event)
      this.showWX = true
    },
    // 关注公众号弹框关闭
    closeQrcodeDialog() {
      this.showWX = false
    },
    // 取消订单
    cancelClick(index) {
      this.currentCancelIndex = index
      this.editData.orderId = this.listsData[index].orderNum // 订单号
      this.showCancelModel = true
    },

    // 确定取消订单
    confirmCancelModel() {
      axios.post(this.Service.Order.ajaxCancelOrder, {
        orderNum: this.editData.orderId
      })
        .then((res) => {
          this.showCancelModel = false
          this.succCancel = true
          if (res.status == 1) {
            this.listsData[this.currentCancelIndex].status = 4 // 成功后不显示取消订单按钮
            this.cacelWarning = '取消订单成功～'
            location.reload()
          } else {
            this.cacelWarning = res.data
          }
        })
        .catch(() => {
          this.showCancelModel = false
          this.succCancel = true
          this.cacelWarning = '取消订单失败，请稍后重试～'
        })
    },

    closeCancelModel() {
      this.currentCancelIndex = -1
      this.showCancelModel = false
    },

    closeSuccCancelModel() {
      this.succCancel = false
    },
    loading(selector) {
      let loadTime = 200
      this.loadingTimer = setTimeout(() => {
        this.loadFlag = true
        if (this.loadFlag) {
          this.loadingInstance = Loading.service({
            target: document.querySelector(selector),
            text: '拼命加载中',
            spinner: 'el-icon-loading',
            fullscreen: false,
            background: 'rgba(255, 255, 255, 0.8)',
            customClass: 'loading'
          })
        }
        clearTimeout(this.loadingTimer)
      }, loadTime)
    },
    checkOrderIsCancel(status) {
      if (status == 1 || status == 2 || status == 3 || status == 6) {
        // 已取消
        return false
      }
      return true
    },
    // 创建付尾款的倒计时
    createTimer(data) {
      data.map((item, index) => {
        if (item.productInfos.length > 1) {
          item.isShowAll = false
        } else {
          item.isShowAll = true
        }
        if (item.orderType == 5 && item.presaleOrderInfo == null) {
          item.presaleOrderInfo = {}
        }
        if (item.orderType == 5 && item.presaleOrderInfo && item.presaleOrderInfo.tailLeftTime > 0 && item.presaleOrderInfo.tailTimeStatus == 2) {
          this.$set(
            item, 'timeStr', this.initTime(item.presaleOrderInfo.tailLeftTime)
          )
        }
      })

      this.listsData = data
      let index = this.listsData.findIndex(item => item.orderType == 5)
      if (index >= 0) {
        if (this.timerArr.length > 0) {
          this.timerArr.forEach(item => {
            if (item) {
              clearInterval(item)
            }
          })
          this.timerArr = []
        }
        let timer = setInterval(() => {
          this.listsData.map((item) => {
            if (item.presaleOrderInfo && item.presaleOrderInfo.tailLeftTime > 0 && item.presaleOrderInfo.tailTimeStatus == 2) {
              item.presaleOrderInfo.tailLeftTime -= 1
              let leftTime = item.presaleOrderInfo.tailLeftTime
              let dd = Math.floor(leftTime / 60 / 60 / 24)
              let hh = Math.floor((leftTime / 60 / 60) % 24)
              let mm = Math.floor((leftTime / 60) % 60)
              let ss = Math.floor(leftTime % 60)
              item['timeStr'] = `<strong>${dd}</strong>天<strong>${hh}</strong>小时<strong>${mm}</strong>分<strong>${ss}</strong>秒后结束`
            } else if (item.presaleOrderInfo && item.presaleOrderInfo.tailLeftTime <= 0 && item.presaleOrderInfo.tailTimeStatus == 2) {
              item['timeStr'] = `尾款支付时间已过`
              item.presaleOrderInfo.tailTimeStatus = 3
              item.presaleOrderInfo.tailStartTime = ''
              clearInterval(timer)
            }
          })
        }, 1000)
        this.timerArr.push(timer)
      }
    },
    initTime(leftTime) {
      let dd = null
      let hh = null
      let mm = null
      let ss = null
      dd = Math.floor(leftTime / 60 / 60 / 24)
      hh = Math.floor((leftTime / 60 / 60) % 24)
      mm = Math.floor((leftTime / 60) % 60)
      ss = Math.floor(leftTime % 60)
      let str = `<strong>${dd}</strong>天<strong>${hh}</strong>小时<strong>${mm}</strong>分<strong>${ss}</strong>秒后结束`
      return str
    },
    getStatusText(status) {
      if (+status === 3) {
        return '退课审核中'
      }
      if (+status === 2) {
        return '课程已调换'
      }
      if (+status === 1) {
        return '已退课'
      }
    }
  },
  destroyed() {
    if (this.timerArr.length > 0) {
      this.timerArr.forEach(item => {
        if (item) {
          clearInterval(item)
        }
      })
      this.timerArr = []
    }
  }
}
</script>

<style lang='less'>
// 退费说明入口
.refund-txt {
  position: absolute;
  top: 17px;
  right: 20px;
  img {
    vertical-align: middle;
  }
  span {
    font-size: 14px;
    font-family: PingFangSC-Regular;
    font-weight: 400;
    color: rgba(51, 51, 51, 1);
    vertical-align: middle;
  }
}
// 调换课popover样式
.exchange-popover {
  padding: 20px 20px 0 20px;
  .exchange-content {
    font-size: 14px;
    font-family: PingFangSC-Regular;
    font-weight: 400;
    li {
      width: 178px;
      padding-bottom: 23px;
      margin-top: 12px;
      &:nth-child(1) {
        border-bottom: 1px solid #dcdcdc;
      }
    }
    .disabled {
      color: #ccc;
      pointer-events: none;
    }
    .not-disabled {
      color: #333;
      cursor: pointer;
    }
    .exchange-icon {
      img {
        margin-right: 8px;
        vertical-align: bottom;
        opacity: 0.6;
        width: 24px;
        height: 24px;
      }
    }
    .exchange-text {
      opacity: 0.6;
    }
    .exchange-tip {
      font-size: 12px;
      margin-left: 35px;
      margin-top: 12px;
      color: rgba(240, 119, 60, 1);
    }
  }
}
.return-style {
  cursor: pointer;
  color: #333333;
  &:hover {
    color: #f13232;
  }
}
.order-wrap {
  position: relative;
}
.order-top {
  position: relative;
  .fun-box {
    position: absolute;
    top: 0;
    left: 100px;
    background: #fff;
    z-index: 1;
    color: #333333;
    font-size: 15px;
    .fun-show {
      width: 80px;
      height: 24px;
      line-height: 22px;
      border: 1px solid #999999;
      display: inline-block;
      font-size: 12px;
      color: #5b6169;
      text-align: center;
      margin-top: 13px;
    }
    .fun-check {
      line-height: 40px;
      font-size: 13px;
      padding-top: 2px;
      box-shadow: 0px 4px 4px 0px rgba(0, 0, 0, 0.08);
      li {
        height: 30px;
        background: #fff;
        width: 80px;
        line-height: 30px;
        text-align: center;
        font-size: 12px;
        color: #666;
        cursor: pointer;
        &:hover {
          background: rgba(153, 153, 153, 0.12);
        }
      }
    }
    .filter-icon {
      width: 8px;
      height: 8px;
      background: url('../assets/img/filter-tangle.png') 0 0 no-repeat;
      background-size: contain;
      transition: 0.3s;
      display: inline-block;
      vertical-align: middle;
      margin-top: -2px;
    }
    .fun-show:hover {
      color: #f13232;
      border-color: #f13232;
      .filter-icon {
        transform: rotate(180deg);
        margin-top: -1px;
        background-image: url('../assets/img/red-filter-tangle.png');
      }
    }
  }
}
.order-wrap .presell-order-list-count {
  color: #999;
  font-weight: normal;
  strong {
    color: #f13232;
    font-weight: normal;
  }
}
.course-name {
  .xue-am-badge {
    display: inline-block;
    min-width: 10px;
    padding: 1px;
    font-size: 12px;
    line-height: 1;
    vertical-align: baseline;
    white-space: nowrap;
    text-align: center;
    border-radius: 2px;
    background-color: transparent;
    border: 1px solid #f13232;
    color: #f13232;
  }
  .text {
    display: inline-block;
    line-height: 16px;
  }
}
.ao-title-wrapper {
  padding: 0 20px;
}
.ao-title {
  height: 50px;
  width: 100%;
  margin-bottom: 20px;
  background-color: #fff;
  border: 1px solid #eaeaea;
  li {
    float: left;
    padding-top: 16px;
    text-align: center;
    color: #666;
    font-size: 12px;
  }
  .ao-first {
    width: 70%;
  }
  .ao-second {
    width: 10%;
  }
  .ao-third {
    width: 20%;
  }
}
.order-lists-loading {
  position: relative;
  min-height: 450px;
  padding-top: 8px; // 防止父子margin合并
}
.order-lists {
  padding: 0 20px;
  .order-wrapper {
    width: 100%;
    margin-bottom: 15px;
    border: solid 1px #e0e0e0;
    color: #666666;
    background-color: #ffffff;
    .order-title-wrapper {
      padding: 10px 20px;
      font-size: 12px;
      background: #f5f5f5;
      position: relative;
      p {
        margin: 0;
      }
      .or-title {
        height: 30px;
        line-height: 30px;
        .number {
          display: inline-block;
          margin-left: 20px;
        }
        .right-tip {
          position: absolute;
          top: 50%;
          right: 20px;
          width: 400px;
          text-align: right;
          transform: translateY(-50%);
          line-height: 20px;
        }
      }
      .or-warning {
        height: 30px;
        line-height: 30px;
        .orange {
          color: #f0773c;
        }
      }
    }
    .bd-top {
      border-top: solid 1px #e0e0e0;
    }
    .order-content-wrapper {
      position: relative;
      display: flex;
      font-size: 12px;
      .sign-red {
        color: #f13232;
        &:hover {
          color: #fa4747;
        }
      }
      &:after {
        content: '';
        display: block;
        clear: both;
      }
      & > div.or-con:last-child {
        border-right: none;
      }
      .order-course-wrapper {
        width: 100%;
        min-height: 100px;
      }
      .or-con {
        -webkit-box-sizing: border-box;
        -moz-box-sizing: border-box;
        -ms-box-sizing: border-box;
        box-sizing: border-box;
        .or-course {
          position: relative;
          padding: 20px;
          border-bottom: solid 1px #e0e0e0;
          &:last-child {
            border-bottom: none;
          }
          .or-con-coupon {
            font-weight: 400;
            display: flex;
            flex-direction: row;
            align-items: center;
            .money-card-left {
              width: 480px;
              display: flex;
              flex-direction: row;
              align-items: center;
              .money-card-ticket {
                display: flex;
                flex-direction: column;
                align-items: center;
                justify-content: center;
                margin-right: 12px;
                width: 80px;
                height: 80px;
                background-color: rgba(224, 158, 39, 0.06);
                color: #e02727;
              }
              .money-card-money {
                font-size: 23px;
              }
              .money-card-sign {
                font-size: 13px;
              }
              .money-card-desc {
                display: -webkit-box;
                overflow: hidden;
                -webkit-box-orient: vertical;
                text-overflow: ellipsis;
                -webkit-line-clamp: 2;
                margin-top: 4px;
                font-size: 12px;
              }
              .money-card-content {
              }
              .money-card-name {
                font-weight: 500;
                font-size: 14px;
                color: #333;
              }
              .money-card-time {
                margin-top: 36px;
                font-size: 12px;
                color: #666;
              }
            }
            .money-card-right {
              .money-card-price {
                margin-left: -3px;
                font-size: 12px;
                color: #666;
              }
              .money-card-num {
                margin-top: 12px;
                font-size: 12px;
                color: #666;
              }
            }
          }
          .or-con-course {
            width: 75%;
            display: inline-block;
            .course-name {
              white-space: nowrap;
              margin-bottom: 12px;
              max-width: 90%;
              .text {
                color: #333;
                max-width: 90%;
                white-space: nowrap;
                overflow: hidden;
                margin-bottom: -3px;
                text-overflow: ellipsis;
                a {
                  font-size: 14px;
                  color: #333333;
                  &:hover {
                    color: #666666;
                  }
                }
              }
              .presell-icon {
                background: #f0773c;
                line-height: 15px;
                font-size: 12px;
                color: #fff;
                border-radius: 2px;
                display: inline-block;
                padding: 1px 3px;
                margin-right: 6px;
              }
            }
            .course-time {
              // margin-bottom: 12px;
              // display: inline-block;
            }
            .course-teacher {
              margin-top: 12px;
              margin-bottom: 0;
              .teach {
                margin-right: 15px;
              }
            }
          }
          .or-con-price {
            display: inline-block;
            vertical-align: top;
          }
          .or-course-operate {
            height: 100%;
            width: 10%;
            position: absolute;
            top: 0;
            right: 0;
            padding: 20px 0;
            background: #ffffff;
            text-align: center;
            border-left: 1px solid #e0e0e0;
            p {
              margin-bottom: 3px;
              &.drop-detail-link,
              a {
                cursor: pointer;
              }
            }
          }
          .exchange-course {
            cursor: pointer;
            color: #333333;
            &:hover {
              color: #f13232;
            }
          }
        }
        .cancel-refund {
          cursor: pointer;
        }
        .or-welfare {
          padding: 10px 20px;
          &:after {
            content: '';
            display: block;
            clear: both;
          }
          .welfare {
            float: left;
            margin-left: 10px;
            margin-right: 10px;
          }
          .welfare-icon {
            float: left;
            width: 32px;
            height: 17px;
            line-height: 15px;
            text-align: center;
            border-radius: 2px;
            color: #ef3232;
            background: rgba(255, 255, 255, 1);
            border-radius: 2px;
            border: 1px solid rgba(241, 50, 50, 1);
            font-size: 12px;
            font-family: PingFangSC;
            font-weight: 400;
            color: rgba(241, 58, 58, 1);
          }
          .welfare-name {
            // width: 60%;
          }
          .welfare-status {
            .welfare-detail {
              margin-right: 10px;
            }
          }
          .welfare-operate {
            width: 15%;
            & > p {
              text-align: right;
            }
            a {
              color: #333333;
              &:hover {
                color: #666666;
              }
            }
          }
        }
      }
      .or-first {
        width: 100%;
        .or-con-course-wrapper {
          border-top: solid 1px #e0e0e0;
          position: relative;
          .or-con-course-left {
            display: inline-block;
            width: 70%;
          }
          .or-con-course-right {
            position: absolute;
            top: 0;
            right: 0;
            width: 10%;
            height: 100%;
            padding-top: 20px;
            border-left: solid 1px #e0e0e0;
            text-align: center;
            & > p {
              color: #777777;
              a {
                color: #333333;
                &:hover {
                  color: #666666;
                }
              }
              .red {
                color: #f13232;
                &:hover {
                  color: #fa4747;
                }
              }
            }
          }
        }
        .show-all {
          cursor: pointer;
          border-top: 1px solid #dcdcdc;
          height: 44px;
          line-height: 44px;
          padding-left: 37.5%;
        }
      }
      .or-position {
        height: 100%;
        width: 10%;
        position: absolute;
        top: 0;
        padding: 20px 0;
        background: #ffffff;
        border-left: solid 1px #e0e0e0;
        border-top: solid 1px #e0e0e0;
        & > p {
          text-align: center;
          color: #777777;
          &:last-child {
            margin: 0;
          }
        }
        a {
          color: #333333;
          &:hover {
            color: #f13232;
          }
        }
      }
      .or-second {
        right: 20%;
        & > p {
          height: 18px;
          line-height: 18px;
          color: #666666;
        }
      }
      .or-third {
        right: 0;
        width: 20%;
        p {
          margin-bottom: 3px;
        }
      }
      .or-forth {
        right: 0;
      }
    }
    .black {
      color: #333333;
      margin-right: 5px;
    }
    .bd-bottom {
      border-bottom: solid 1px #e0e0e0;
    }
    .no-border {
      border: none;
    }
    // 余下2项样式
    .expand-remain {
      border-top: 1px solid #e0e0e0;
    }
    .pre-sell-order {
      border-top: solid 1px #e0e0e0;
    }
    .pre-sell-stage {
      padding: 12px 0;
      font-size: 12px;
      color: #333333;
      line-height: 17px;

      .stage-left {
        width: 80%;
        padding-right: 2%;
        overflow: hidden;
        display: inline-block;
        vertical-align: text-top;
        padding-left: 20px;
        .price-info {
          float: right;
          text-align: right;
          color: #666666;
          p + p {
            margin-top: 11px;
          }
        }
        .time-info {
          margin-top: 12px;
        }
      }
      .price-red {
        color: #f13232;
      }
      .disabled-stage-left {
        color: #999;
        .price-info {
          color: #999;
        }
      }
      .status-desc,
      .operate-button-wrapper {
        width: 10%;
        text-align: center;
        display: inline-block;
        margin-left: -4px;
        color: #666;
      }
      .status-desc-disabled {
        color: #999;
      }
      .operate-button-wrapper {
        a {
          display: inline-block;
          width: 80px;
          height: 24px;
          background: #f13232;
          border-radius: 2px;
          font-size: 12px;
          color: #fff;
          line-height: 24px;
          margin: 0 auto;
        }
      }
      & + .pre-sell-stage {
        border-top: solid 1px #e0e0e0;
      }
    }
  }
}
.ao-course-remarks {
  margin: 0;
  font-size: 12px;
  color: #333;
  .blue {
    color: #3bafda;
  }
  .courseQrcode-btn {
    cursor: pointer;
  }
}
.cancel-wrapper {
  // min-height: 162px;
  .product-reduce-info {
    overflow: auto;
    margin-top: 16px;
    padding-left: 40px;
    margin-bottom: 32px;
    max-height: 200px;
    min-height: 80px;
    .product-item {
      line-height: 24px;
      font-size: 14px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: rgba(51, 51, 51, 1);
    }
  }
  .reduce-title {
    text-align: left;
    padding-left: 40px;
    padding-right: 40px;
    font-size: 16px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
    color: rgba(51, 51, 51, 1);
  }
  .cancel-common-title {
    text-align: center;
    padding-left: 40px;
    padding-right: 40px;
  }
  .cancel-text {
    text-align: center;
    padding-left: 50px;
    padding-right: 50px;
  }
  .cancel-center {
    text-align: center;
  }
  .cancel-left {
    text-align: left;
  }
  .ok-btn {
    text-align: center;
    width: 140px;
    height: 40px;
    background: rgba(241, 50, 50, 1);
    border-radius: 2px;
    color: #fff;
    cursor: pointer;
  }
  .cancel-btn {
    width: 140px;
    height: 40px;
    background: rgba(255, 255, 255, 1);
    border-radius: 2px;
    border: 1px solid rgba(222, 222, 222, 1);
    color: rgba(51, 51, 51, 1);
    margin-right: 24px;
    cursor: pointer;
  }
  .confirm-btn {
    width: 140px;
    height: 40px;
    background: rgba(241, 50, 50, 1);
    border-radius: 2px;
    color: #fff;
    cursor: pointer;
    border: 1px solid transparent;
    outline: none;
  }
  .cancel-order {
    width: 340px;
    left: 15px;
    bottom: 20px;
    margin-top: 32px;
  }
  .reduce-cancel {
    left: 96px;
  }
  .cancel-footer {
    text-align: center;
    margin-bottom: 32px;
    margin-top: 32px;
  }
}
.order-lists-loading .order-page {
  text-align: center;
  .btn-next,
  .btn-prev,
  .el-dialog,
  .el-pager li,
  .el-pagination button.disabled,
  .el-pager li.btn-quicknext,
  .el-pager li.btn-quickprev {
    background: #e0e0e0;
    color: #ffffff;
    font-size: 14px;
    height: 39px;
    width: 45px;
    line-height: 39px;
    margin-left: 1px;
  }
  .el-pagination button.disabled {
    cursor: default;
  }
  .btn-next {
    border-radius: 0 3px 3px 0;
  }
  .btn-prev {
    border-radius: 3px 0 0 3px;
  }
  .btn-next {
    margin: 0 2px;
  }
  .btn-prev {
    margin: 0 1px;
  }
  .el-pager li.active {
    color: #ffffff;
    background: #f13232;
    font-size: 14px;
  }
  .el-pager li:hover,
  .btn-next:hover,
  .btn-prev:hover {
    color: #ffffff;
    background: #f13232;
  }
  .el-pagination .disabled:hover {
    background: #e0e0e0;
  }
  .btn-next .el-icon,
  .btn-prev .el-icon {
    font-weight: 900;
    font-size: 14px;
  }
  .el-pagination button:disabled {
    color: #ffffff;
    background-color: #fff;
    cursor: not-allowed;
    background: #e0e0e0;
  }
}
</style>

<style lang="less" scoped>
.broadcast-message {
  margin-top: -10px;
  display: flex;
  align-items: center;
  box-sizing: border-box;
  padding: 10px 12px;
  background: #fff5e0;
  font-size: 13px;
  color: #e29a09;
  img {
    display: inline-block;
    width: 14px;
    margin-right: 8px;
  }
}
</style>


// WEBPACK FOOTER //
// module/order/src/components/OrderList.vue